import { heroes } from "../data/Heroes";


export const getHeroesByPublicher = (publisher) => {

    const validPublichers = ['DC Comics', 'Marvel Comics']

    if (!validPublichers.includes(publisher)) {
        throw new Error(`publicher "${publisher}" no es correcto `)
    };

    return heroes.filter(hero => hero.publisher === publisher);
    //el publisher que tenga en mi arreglo heroes deve ser igual al que mando por props
}